import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'


class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detailData: {},
            uuid: new URLSearchParams(window.location.search).get('uuid'),
            gagal_txt : ''
        }
    }
    
    loadDetail = async () => {
        await this.updateBloc.fetchDetail({uuid: this.state.uuid })
    }
    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }
    checkData = async () => {
        await this.updateBloc.fetchCheck(this.state.dataForm)
    }
    
    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 
        
        this.setState({
            dataForm: values,
            confirm: true
        })
    }
    
    confirmResponse = (response) => {
        let forState = {}
        this.setState({
            gagal_txt: "Gagal!"
        })
        switch(response) {
            case 'cancel':
        forState = {
            confirm: false
        }
        break;
        case 'confirm':
            forState = {
                loading: true,
                confirm: false
            }
            this.checkData()
            break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
                case 'failed':
                    forState = {
                        failed: false
                    }
                    break;
                    default:       
                }
                this.setState(forState)
            }
                    
        componentDidMount() {
            // const queryParams = new URLSearchParams(window.location.search)
            // console.log(this.state.uuid)
            // this.loadDetail()
            this.updateBloc.detailChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                        if(result.data.status) {
                            let response = result.data.response
                            this.setState({
                                detailData: response
                            })
                        }
                        break
                    case apiResponse.ERROR:
                        break
                    default:
                    break
                    }
            })
            this.updateBloc.fetchDetail({uuid: this.state.uuid })
            this.updateBloc.createChannel.subscribe((result) => {
                switch (result.status) {
                    case apiResponse.COMPLETED:
                this.setState({
                    loading: false,
                    success: true,
                });
                break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                break
                }
            })
        this.updateBloc.checkChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result.data.response)
                    // this.setState({
                    //     loading: false,
                    //     success: true,
                    // });
                    if(result.data.response==0){
                        this.submitData()
                    }else{
                        this.setState({
                            gagal_txt: "Tanggal Hari Libur Sudah ada",
                            loading: false,
                            failed: true,
                        });
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

       
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Ubah Data Hari Libur</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Ubah data Hari Libur 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Hari Libur <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="uuid"
                                                    type="hidden"
                                                    id="uuid"
                                                    value={this.state.uuid}
                                                />
                                                <AvField
                                                    name="hollyday_name"
                                                    placeholder="Nama Hari Libur..."
                                                    type="text"
                                                    errorMessage="Hari Libur"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="hollyday_name"
                                                    value={this.state.detailData.holiday_name}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="hollyday_date"
                                                    placeholder="Masukan Tanggal..."
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Hari Libur"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="hollyday_date"
                                                    value={this.state.detailData.holiday_date}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/hari_libur.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/hari_libur.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView